import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import AddressIcon from "src/assets/all-icons/address-icon.jsx";
import CookiesIcon from "src/assets/all-icons/cookies-icon.jsx";
import CreditCardIcon from "src/assets/all-icons/credit-card-icon.jsx";
import EditArtworkIcon from "src/assets/all-icons/edit-artwork-icon.jsx";
import ModeAndThemeIcon from "src/assets/all-icons/mode-and-theme-icon.jsx";
import PrivacyPoliciesIcon from "src/assets/all-icons/privacy-policies-icon.jsx";
import TermsOfUseIcon from "src/assets/all-icons/terms-of-use-icon.jsx";
import UserIcon from "src/assets/all-icons/user-icon.jsx";

import GalleryIcon from '@/assets/all-icons/gallery-icon';
import useStateHandler from '@/hooks/useStateHandler';
import LogoutConfirmation from '@/layouts/navigation/user-settings/components/LogoutConfirmation';
import AuthService from '@/services/auth.service';
import DeleteAccountDialog from '@/shared-components/popups/components/DeleteAccountDialog';
import Text from '@/shared-components/text/components/Text';

import './styles/SettingsMenu.css';

function SettingsMenuNavLink({ to, Icon, iconClassName, text, replace }) {
  return (
    <>
      <NavLink 
        className={({ isActive }) =>`settings-menu__menu-link${isActive ? " active" : ""}`} 
        to={to} 
        state={{ from: true }} 
        replace={replace}
      >
        <div className="settings-menu__menu-link-icon-container">
          <Icon className={`settings-menu__menu-link-icon ${iconClassName}`}/>
        </div>

        <Text className="settings-menu__menu-link-text" medium>
          {text}
        </Text>
      </NavLink>
    </>
  );
}

export default function SettingsMenu({ replace=false }) {
  const { state } = useStateHandler();
  const [logoutDialog, setLogoutDialog] = useState(false);
  const [ confirmDeletionDialog, setConfirmDeletionDialog] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="settings-menu__container">
        <Text className="settings-menu__menu-heading" large>
                    Account
        </Text>

        <div className="settings-menu__section element-non-selectable">
          <SettingsMenuNavLink 
            to="/profile/settings/edit-profile" 
            iconClassName="edit" 
            text="Edit profile" 
            Icon={EditArtworkIcon}
            replace={replace}
          />

          <SettingsMenuNavLink 
            to="/profile/settings/login" 
            iconClassName="user" 
            text="Log in" 
            Icon={UserIcon}
            replace={replace}
          />

          {
            state.user_session.user_type === "gallery" ? 
              <>
                <SettingsMenuNavLink 
                  to="/profile/settings/gallery-information" 
                  iconClassName="gallery" 
                  text="Gallery's information" 
                  Icon={GalleryIcon}
                  replace={replace}
                /> 

                <SettingsMenuNavLink 
                  to="/profile/settings/bank-account" 
                  iconClassName="credit" 
                  text="Bank account"
                  Icon={CreditCardIcon}
                  replace={replace}
                />
              </>
              :
              <>

                <SettingsMenuNavLink 
                  to="/profile/settings/address" 
                  iconClassName="house" 
                  text="Address" 
                  Icon={AddressIcon}
                  replace={replace}
                />
              </> 
          }
        </div>

        <Text className="settings-menu__menu-heading" large>
                    Preferences
        </Text>

        <div className="settings-menu__section element-non-selectable">
          <SettingsMenuNavLink 
            to="/profile/settings/mode-theme" 
            iconClassName="mode-theme" 
            text="Mode and theme" 
            Icon={ModeAndThemeIcon}
            replace={replace}
          />

          {/* <SettingsMenuNavLink 
                        to="/profile/settings/notifications" 
                        iconClassName="notifications" 
                        text="Notifications" 
                        Icon={ProfileNotificationsIcon}
                        replace={replace}
                    /> */}
        </div>

        <Text className="settings-menu__menu-heading" large>
                    About
        </Text>

        <div className="settings-menu__section element-non-selectable">
          <SettingsMenuNavLink 
            to="/profile/settings/privacy" 
            iconClassName="privacy" 
            text="Privacy policies" 
            Icon={PrivacyPoliciesIcon}
            replace={replace}
          />

          <SettingsMenuNavLink
            to="/profile/settings/terms" 
            iconClassName="terms" 
            text="Terms of use" 
            Icon={TermsOfUseIcon}
            replace={replace}
          />

          <SettingsMenuNavLink 
            to="/profile/settings/cookies" 
            iconClassName="cookies" 
            text="Cookies" 
            Icon={CookiesIcon}
            replace={replace}
          />
        </div>

        {state.user_session.user_type === "gallery" && (
          <Text className="settings-menu__text-button element-non-selectable" large onClick={()=>{
            navigate("/profile/settings/closed-mode", { state: { from: true }, replace: replace });
          }}>
                        Closed mode
          </Text>
        )}

        <Text className="settings-menu__text-button element-non-selectable" large onClick={()=>setLogoutDialog(true)}>
                    Log out
        </Text>

        <Text className="settings-menu__text-button element-non-selectable" large onClick={()=>setConfirmDeletionDialog(true)}>
                    Delete account
        </Text>
      </div>

      {/* Log out confirmation Popup */}
      <LogoutConfirmation 
        open={logoutDialog} 
        onClose={() => setLogoutDialog(false)} 
        onConfirm={AuthService.logout} 
      />

      <DeleteAccountDialog open={confirmDeletionDialog} setOpen={setConfirmDeletionDialog}  />
    </>
  );
}
